import { Account, Proposal } from "align-sdk";
import BN from "bn.js";
import * as dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime';

//a function that takes a bignumber unix timestamp and returns a string of the date
export const unixToDate = (unix: BN) => {
	  const date = new Date(unix.toNumber() * 1000);
	  return date;
};

export const timeLeft = (rankingAtString: string, rankingPeriod: number) => {
	dayjs.extend(relativeTime);
	const rankingAt = new Date(rankingAtString);
	const closeDate = dayjs.default(rankingAt).add(rankingPeriod, 'second')
	return closeDate.fromNow();
}